<template>
  <v-container fluid>
    <v-card elevation="1">
      <v-toolbar color="secondary" dark shaped>
        <h3 class="title">{{$route.name}}</h3>
      </v-toolbar>
      <v-card-text style="padding:20px">
        <v-container>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-autocomplete
                  label="Fornecedor:"
                  :rules="fieldRules"
                  :items="providers"
                  @change="loadItems(data.provider_id)"
                  item-value="provider_id"
                  item-text="provider_name"
                  v-model="data.provider_id"
                />
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-autocomplete
                  label="Item:"
                  :rules="fieldRules"
                  :items="items"
                  item-value="item_id"
                  item-text="item_name"
                  v-model="data.item_id"
                >
                  <template
                    slot="selection"
                    slot-scope="{ item }"
                  >{{ item.item_description_desc }} preço R$: {{ realMask(item.item_price.toFixed(2)) }}</template>
                  <template
                    slot="item"
                    slot-scope="{ item }"
                  >{{ item.item_description_desc }} preço R$: {{ realMask(item.item_price.toFixed(2)) }}</template>
                </v-autocomplete>
              </v-col>
              <!-- <v-col cols="12" sm="12" md="6">
                <v-autocomplete
                  label="Veículo:"
                  :rules="fieldRules"
                  :items="vehicles"
                  item-value="vehicle_id"
                  v-model="data.vehicle_id"
                >
                  <template
                    slot="selection"
                    slot-scope="{ item }"
                  >{{ item.brand_desc }} - {{ item.model_desc }} - {{ item.vehicle_board }}</template>
                  <template
                    slot="item"
                    slot-scope="{ item }"
                  >{{ item.brand_desc }} - {{ item.model_desc }} - {{ item.vehicle_board }}</template>
                </v-autocomplete>
              </v-col>-->
              <v-col cols="12" sm="12" md="6">
                <v-autocomplete
                  label="Motorista:"
                  :items="drivers"
                  item-value="driver_id"
                  item-text="driver_name"
                  v-model="data.driver_id"
                  append-icon="mdi-plus"
                  @click:append="showForm = true"
                />
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-text-field
                  label="Litros Autorizados"
                  v-model="data.supply_authorized_liters"
                  v-mask-decimal.br="3"
                  :disabled="data.supply_authorized_value ? true : false"
                />
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-text-field
                  label="Valor Autorizado"
                  v-model="data.supply_authorized_value"
                  v-mask-decimal.br="2"
                  :disabled="data.supply_authorized_liters ? true : false"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>

      <v-dialog v-model="showForm" width="500">
        <v-card>
          <v-toolbar color="secondary" dark shaped>
            <h3 class="title">Cadastrar Motorista</h3>
          </v-toolbar>
          <v-card-text>
            <v-form @submit.prevent="newDriver">
              <v-text-field
                class="mb-6 mt-6"
                :rules="fieldRules"
                label="nome do motorista"
                v-model="driver_name"
              />
              <v-footer absolute>
                <v-spacer />
                <v-btn text color="error" @click="[showForm = false, driver_name = '']">Cancelar</v-btn>
                <v-btn
                  text
                  color="primary"
                  :disabled="driver_name ? false : true"
                  :loading="loader"
                  @click="newDriver"
                >Confirmar</v-btn>
              </v-footer>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
      
      <v-footer style="padding:10px">
        <v-spacer />
        <v-btn
          :disabled="!valid && loader"
          depressed
          large
          color="primary"
          class="mr-4"
          :loading="loader"
          @click="validate"
        >Confirmar</v-btn>
      </v-footer>
    </v-card>

    <v-dialog v-model="showPassword" width="300" persistent>
      <v-card>
        <v-card-title class="headline primary lighten-2 text-center">COPIE SUA SENHA</v-card-title>
        <v-card-text class="mt-6 text-center">
          <v-row>
            <v-col cols="12" sm="12">
              <v-label>
                <input
                  readonly
                  class="text-h4 text-center"
                  style="width:100%;border:0;outline:none"
                  ref="copiar"
                  :value="password"
                />
              </v-label>
            </v-col>
            <v-col cols="12" sm="12">
              <v-btn
                :color="copiado ? 'green' : 'primary'"
                depressed
                :dark="copiado"
                block
                @click="copy"
                :outlined="!copiado"
              >
                <v-icon v-if="copiado">mdi-check</v-icon>
                {{copiado ? 'COPIADO' : 'COPIAR'}}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar multi-line :color="snack.color" v-model="snack.show" transition="fade-transition">
      {{snack.message}}
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="snack.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import Helpers from "@/mixins/helpers.js";
export default {
  props: ["id"],
  mixins: [Helpers],
  data: () => ({
    valid: false,
    loader: false,
    showForm: false,
    showPassword: false,
    copiado: false,
    password: "",
    providers: [],
    drivers: [],
    vehicles: [],
    items: [],
    driver_name: "",
    fieldRules: [(v) => !!v || "Este campo é requerido"],
    snack: {
      show: false,
      message: "",
      color: "success",
    },
    data: {
      supply_id: null,
      supply_authorized_liters: "0",
      supply_authorized_value: "0",
      supply_status: "AUTORIZADO",
      supply_adjusted: false,
      supply_extra: true,
      supply_liters_stocked: false,
      supply_billed: false,
      vehicle_id: null,
      driver_id: null,
      item_id: null,
      prefecture_id: null,
      provider_id: null,
    },
  }),
  created() {
    this.Helpers;
    this.$http
      .get(`/providers/prefecture/${this.$store.getters.getUserData.table_id}`)
      .then((r) => (this.providers = r.data));
    this.$http
      .get(`/supplies/drivers/${this.$store.getters.getUserData.table_id}`)
      .then((r) => (this.drivers = r.data));
    this.$http
      .get(`/supplies/vehicles/${this.$store.getters.getUserData.table_id}`)
      .then((r) => (this.vehicles = r.data));
    this.data.prefecture_id = this.$store.getters.getUserData.table_id;
    if (this.id) {
      this.$store.dispatch("setLoader", true);
      this.$http.get(`supplies/single/${this.id}`).then((r) => {
        this.data = r.data[0];
        this.$http
          .get(`/supplies/providers/${r.data[0].provider_id}`)
          .then((i) => {
            this.items = i.data;
            this.dialog = true;
          });
        delete this.data.datehour;
        delete this.data.supply_liters_stocked;
        delete this.data.supply_price_day;
        this.$store.dispatch("setLoader", false);
      });
    }
  },
  methods: {
    copy() {
      var copyTextarea = this.$refs.copiar;
      copyTextarea.select();
      try {
        var successful = document.execCommand("copy");
        if (successful) {
          this.copiado = true;
          setTimeout(() => {
            this.showPassword = false;
            this.copiado = false;
            this.$router.push("/supplies-manager");
          }, 1000);
        } else {
          alert("não copiado!");
        }
      } catch (err) {
        alert(
          "Opa, Não conseguimos copiar o texto, é possivel que o seu navegador não tenha suporte, tente usar Crtl+C."
        );
      }
    },
    loadItems(provider_id) {
      this.$http
        .get(`/supplies/providers/${provider_id}`)
        .then((r) => (this.items = r.data));
    },
    newDriver() {
      this.loader = true;
      this.$store.dispatch("setLoader", this.loader);
      this.$http
        .post("/supplies/drivers", {
          driver_name: this.driver_name,
          prefecture_id: this.data.prefecture_id,
        })
        .then((r) => {
          this.snack.show = true;
          this.snack.message = r.data.result;
          this.snack.color = "success";
          this.loader = false;
          this.$store.dispatch("setLoader", this.loader);
          this.$http.get("/drivers").then((d) => {
            this.drivers = d.data;
            const driverItems = d.data.filter((f) =>
              f.driver_name === this.driver_name ? f : null
            );
            console.log(driverItems[0].driver_id);
            this.data.driver_id = driverItems[0].driver_id;
            this.showForm = false;
          });
        })
        .catch((e) => {
          this.snack.show = true;
          this.snack.color = "error";
          this.snack.message = e.message;
          this.loader = false;
          this.$store.dispatch("setLoader", this.loader);
        });
    },
    validate() {
      this.snack.show = true;
      this.loader = true;
      if (this.$refs.form.validate()) {
        this.createOrUpdate();
      } else {
        this.snack.show = true;
        this.snack.color = "warning";
        this.snack.message =
          "Atencão um ou mais campos precisam ser preenchidos!";
        this.loader = false;
      }
    },
    checkFields() {
      if (this.data.supply_authorized_value) {
        this.data.supply_authorized_liters = 0;
      } else {
        this.data.supply_authorized_value = 0;
      }
    },
    createOrUpdate() {
      this.loader = true;
      this.checkFields();
      if (this.id) {
        this.$store.dispatch("setLoader", this.loader);
        this.$http
          .put(`/supplies/single/${this.id}`, this.data)
          .then((r) => {
            this.snack.show = true;
            this.snack.message = r.data.result;
            this.loader = true;
            setTimeout(() => {
              this.$router.push("/supplies-manager");
            }, 1500);
            this.$store.dispatch("setLoader", this.loader);
          })
          .catch((e) => {
            this.snack.show = true;
            this.snack.message = e.message;
            this.snack.color = "error";
            this.loader = false;
            this.$store.dispatch("setLoader", false);
          });
      } else {
        this.$store.dispatch("setLoader", this.loader);
        this.$http
          .post("/supplies/single", this.data)
          .then((r) => {
            this.showPassword = true;
            this.$http
              .get(`/supplies/single/${r.data.idInserted}`)
              .then((r) => (this.password = r.data[0].supply_code));
            this.snack.show = true;
            this.snack.message = r.data.result;
            this.snack.color = "success";
            this.loader = false;
            this.$store.dispatch("setLoader", this.loader);
          })
          .catch((e) => {
            this.snack.show = true;
            this.snack.message = e.message;
            this.snack.color = "error";
            this.loader = false;
            this.$store.dispatch("setLoader", false);
          });
      }
    },
  },
};
</script>

<style>
.title {
  text-transform: uppercase;
  font-weight: 400;
}

.flexd {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.flexd p {
  margin: 10px 0;
  font-weight: bold;
  text-transform: uppercase;
}
</style>